/**
 * Severity-ordered categories for the timesheet list view. The array is the
 * single source of truth: index 0 is the highest severity, the type derives
 * from the array contents, and `compareTimesheetCategories` reads positions
 * back off the same array.
 */
export const TIMESHEET_CATEGORIES = [
  'REQUIRES_ATTENTION',
  'IN_PROGRESS',
  'STARTING_SOON',
  'READY_FOR_APPROVAL',
  'APPROVED',
  'DECLINED',
] as const;

export type TimesheetCategory = (typeof TIMESHEET_CATEGORIES)[number];

/** Negative when `a` is more severe than `b`. */
export function compareTimesheetCategories(a: TimesheetCategory, b: TimesheetCategory): number {
  return TIMESHEET_CATEGORIES.indexOf(a) - TIMESHEET_CATEGORIES.indexOf(b);
}
